import {
  CardTypes,
  CreditCardsDto,
  InvoicesDto,
  PaymentMethod,
  PaymentType,
  UserWalletConfigDto,
  UserWalletConfigModel
} from '../models/payments';

function getCardType(cardName: string) {
  switch (cardName.toUpperCase()) {
    case 'VISA':
      return CardTypes.VISA;
    case 'MASTERCARD':
      return CardTypes.MASTERCARD;
  }
}

export const invoiceDtoToPaymentMethods = ({ invoices }: InvoicesDto): PaymentMethod[] => {
  if (!invoices) {
    return [];
  }
  return invoices.map(item => {
    const paymentMethod: PaymentMethod = {
      paymentType: PaymentType.INVOICE,
      id: item.id,
      display: item.display,
      isReferenceRequired: item.is_reference_required
    };
    return paymentMethod;
  });
};

export const creditCardDtoToPaymentMethod = ({ cards }: CreditCardsDto): PaymentMethod[] => {
  if (!cards) {
    return [];
  }
  return cards.map(item => {
    const paymentMethod: PaymentMethod = {
      paymentType: PaymentType.CREDIT_CARD,
      id: item.id,
      display: `**** ${item.last_4}`,
      cardType: getCardType(item.type),
      //TODO: refactor when v2 rolled out
      expiryDate: item.expire_month ? `${item.expire_month}/${item.expire_year}` : undefined
    };
    return paymentMethod;
  });
};

export const userWalletConfigDtoToModel = ({
  is_zero_wallet_balance,
  wallet_details: { amount: smallerUnits, currency, fraction_digits }
}: UserWalletConfigDto): UserWalletConfigModel => {
  const amount = !isNaN(smallerUnits) ? smallerUnits / Math.pow(10, fraction_digits) : smallerUnits;
  return {
    isZeroWalletBalance: is_zero_wallet_balance,
    userBalance: {
      amount,
      currency,
      fractionDigits: fraction_digits
    }
  };
};
